if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  // setTimeout(() => {
  //   const observer = new MutationObserver((MutationList) => {
  //     // console.log(MutationList);
  //     for (let item of MutationList) {
  //       if (item.target.classList.contains("quickview-content")) {
  //         document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
  //       }
  //       if (item.target.id === "Cart-Icon-Bubble") {
  //         BSS_B2B.observer.cartSubject.listenCartCheckout();
  //       }
  //     }
  //   });
  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true,
  //   });
  // }, 300);

  // const checkUpcartInterval = setInterval(() => {
  //   const upcartEl = document.querySelector("#upCart");

  //   if (upcartEl) {
  //     clearInterval(checkUpcartInterval);
  //     handleUpCart();
  //   }
  // }, 100);

  // setTimeout(() => {
  //   clearInterval(checkUpcartInterval);
  // }, 5000);

  // document.addEventListener(
  //   "bss_b2b:CustomCartUpdate",
  //   (e) => {
  //     hideLinePriceUpCart();
  //     setTimeout((e) => {
  //       handleUpCart();
  //       setTimeout(() => {
  //         showLinePriceUpCart();
  //       }, 2000);
  //     }, 1000);
  //   },
  //   1
  // );

  // function handleUpCart() {
  //   const el = document.getElementById("upCart");
  //   const shadow = el?.shadowRoot;
  //   const button = shadow.querySelectorAll(".styles_ProductRow__product__");
  //   button.forEach((e) => {
  //     let cartkey = e.getAttribute("id");
  //     e.setAttribute("bss-b2b-cart-item-key", cartkey);
  //     let price = e.querySelector(".upcart-item-price");
  //     price.setAttribute("bss-b2b-final-line-price", "");
  //   });
  //   BSS_B2B.observer.cartSubject.notifyObserver("CartUpdate", "CartMutate");
  // }
  // function hideLinePriceUpCart() {
  //   const elementLinePrice = document
  //     .querySelector("#upCart")
  //     .shadowRoot.querySelectorAll(`.upcart-item-price`);
  //   elementLinePrice.forEach((lineItem) => {
  //     lineItem.style.visibility = "hidden";
  //   });
  // }
  // function showLinePriceUpCart() {
  //   const elementLinePrice = document
  //     .querySelector("#upCart")
  //     .shadowRoot.querySelectorAll(`.upcart-item-price`);
  //   elementLinePrice.forEach((lineItem) => {
  //     lineItem.style.visibility = "visible";
  //   });
  // }



  document.addEventListener("DOMContentLoaded", () => {
    const inputSearch = document.querySelector(`#Inline-Search`);
    if (!inputSearch) return;

    let debounceTimer;
    inputSearch.addEventListener("input", (e) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        window.dispatchEvent(new Event('scroll'));
        console.log(123)
      }, 300);
    });
  });

}


